import PeripheralBridge from './peripheralBridge'
import { codeAlreadyUsed } from '../VNUtil/VNUtils'
import { ToastManager } from './toastManager'

export const toastError = (message, isMobile) => {
  const options = {
    autoClose: true,
    position: 'top-center',
    className: `toast-scan-screen-md`,
  }
  if (isMobile) {
    options.position = 'bottom-center'
    options.className = null
  }

  ToastManager.error(message, options)
}

export const onMountScanScreen = (handleFocusChange) => {
  document.addEventListener('focusin', handleFocusChange)
  document.addEventListener('focusout', handleFocusChange)

  handleFocusChange({
    type: 'initial',
    target: document.activeElement,
  })

  return () => {
    document.removeEventListener('focusin', handleFocusChange)
    document.removeEventListener('focusout', handleFocusChange)
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return
    bridgeInstance.call('stopScanner')
  }
}

export const makeSegmentChoices = (paymentType) => {
  return [
    { label: `Scan Code`, value: 'scan' },
    { label: `Type Code`, value: 'entry' },
  ]
}

export const registerScanListeners = ({
  order,
  onSuccess,
  paymentType,
  setSelectedSubmissionType,
  isMobile,
  setScanError,
  fromBalanceLookup,
}) => {
  const bridgeInstance = PeripheralBridge.getBridge()
  bridgeInstance.registerHandler('scanPayload', function (data, callback) {
    const scannedCode = data?.valueOf()
    if (!fromBalanceLookup && codeAlreadyUsed(order, scannedCode)) {
      toastError(`${paymentType} already scanned and applied to order`, isMobile)
      return
    }

    setScanError(false)
    onSuccess(scannedCode)
  })

  bridgeInstance.registerHandler('scanError', function (err, callback) {
    if (err?.toLowerCase()?.includes('no scanner detected')) {
      setSelectedSubmissionType('entry')
    }
    toastError(`${paymentType} scan error, ERROR: ${JSON.stringify(err)}`, isMobile)
    setScanError(true)
  })
}
